import { type RouteObject } from "react-router";

import { ME_LOADER } from "@application/loaders/me_loader";

import { DASHBOARD_LINK } from "@application/navigation/dashboard_link";

import { DASHBOARD_AGENTS_ROUTE } from "./agents/route";
import { DashboardApp } from "./app";
import { DASHBOARD_ARTIFACTS_ROUTE } from "./artifacts/route";
import { DASHBOARD_BILLING_ROUTE } from "./billing/route";
import { DASHBOARD_CONNECTIONS_ROUTE } from "./connections/route";
import { DASHBOARD_CONVERSATIONS_ROUTE } from "./conversations/route";
import { DashboardHome } from "./dashboard_home";
import { DashboardErrorBoundary } from "./error_boundary";
import { DASHBOARD_ORGANIZATIONS_ROUTE } from "./organizations/route";
import { DASHBOARD_PROJECTS_ROUTE } from "./projects/route";
import { DASHBOARD_PROMPTS_ROUTE } from "./prompts/route";
import { DASHBOARD_RUNS_ROUTE } from "./runs/route";
import { DASHBOARD_SETTINGS_ROUTE } from "./settings/route";
import { DASHBOARD_SKILLS_ROUTE } from "./skills/route";
import { DASHBOARD_STRIPE_ROUTE } from "./stripe/route";
import { DASHBOARD_TRIGGERS_ROUTE } from "./triggers/route";
import { DASHBOARD_USERS_ROUTE } from "./users/route";
import { DASHBOARD_WORKFLOWS_ROUTE } from "./workflows/route";

export const DASHBOARD_ROUTE = {
  path: "dashboard",
  element: <DashboardApp />,
  errorElement: <DashboardErrorBoundary />,
  loader: ME_LOADER,
  handle: DASHBOARD_LINK,
  children: [
    DASHBOARD_WORKFLOWS_ROUTE,
    DASHBOARD_RUNS_ROUTE,
    DASHBOARD_SKILLS_ROUTE,
    DASHBOARD_USERS_ROUTE,
    DASHBOARD_TRIGGERS_ROUTE,
    DASHBOARD_BILLING_ROUTE,
    DASHBOARD_STRIPE_ROUTE,
    DASHBOARD_CONNECTIONS_ROUTE,
    DASHBOARD_AGENTS_ROUTE,
    DASHBOARD_ARTIFACTS_ROUTE,
    DASHBOARD_CONVERSATIONS_ROUTE,
    DASHBOARD_PROJECTS_ROUTE,
    DASHBOARD_PROMPTS_ROUTE,
    DASHBOARD_SETTINGS_ROUTE,
    DASHBOARD_ORGANIZATIONS_ROUTE,
    {
      index: true,
      element: <DashboardHome />,
    },
  ],
} satisfies RouteObject;
